import { useEffect } from 'react';
import aa from 'search-insights';

import { ALGOLIA_API_KEY, ALGOLIA_APP_ID } from '@/lib/const';

export const useSearchInsights = () => {
  useEffect(() => {
    aa('init', {
      appId: ALGOLIA_APP_ID,
      apiKey: ALGOLIA_API_KEY,
    });
  }, []);
};
